import {locationGrouping} from "../common/location-helper";

export const GroupedLocations = (props) => (
    <span>{locationGrouping(props.record["pickupLocation"])}</span>
);
